
import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../../../theme";

import AddIcon from '@mui/icons-material/Add';
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import ButtonGroup from "../../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../../components/theme/buttons/Shbutton";
import ShDataGrid2 from "../../../../../components/theme/datagrid2/ShDataGrid2";
import ShLabel from "../../../../../components/theme/label/ShLabel";
import ShLabelSkeleton from "../../../../../components/theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../../../components/theme/skeleton/ShTextSkeleton";
import Text from "../../../../../components/theme/text/Text";
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
// import SpRelationDetails from "../../../../../components/global/Sidepanels/SpRelationDetails/SpRelationDetails";
// import SpInvoiceDetails from "../../../../../components/global/Sidepanels/SpInvoiceDetails/SpInvoiceDetails";
import { WarehouseInvoiceCard } from "../../../../../components/global/cards/financial/InvoiceCard";
import SidepanelLoader from "../../../../../components/theme/sidepanel2/SidepanelLoader";
import { formatPrice } from "../../../../../utils/helpers";
import { getShipmentStatusLabeldata } from "../../../../../utils/labelColorText";
import { selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from '../../../../../utils/permissions';
import { useSelector } from "react-redux";
import { SHIPMENTS_FILTER_KEYS } from "../../../../../components/global/DataGrid/Filter";
import ShCopyButton from '../../../../../components/theme/ShCopy';
import { useGetRelationsSelectQuery } from "../../../../../newapi/global/relation/relationSlice";
import { showToastMessage, showToastMessageRequestError, showToastMessageUpdateRequest } from "../../../../../utils/toasts";
import { useBulkUpdateShipmentsMutation, useGetShipmentsQuery } from "../../../../../newapi/order/shipmentsSlice";
import { useExportShipmentsMutation } from "../../../../../newapi/order/ordersSlice";
import { general_states } from "../../../../../utils/staticEnums";
import MDynamicValues from "../../../../../components/global/Modals/MDynamicValues";
import { useGetShippersSelectQuery } from "../../../../../newapi/shipper/shipperSlice";
import SHQuickAction from "../../../../../components/theme/Modal/SHQuickAction";
import MLoader from "../../../../../components/global/Modals/MLoader";
import ShDataGridSelectedActions from "../../../../../components/theme/datagrid2/ShDataGridSelectedActions";
import MConfirmation from "../../../../../components/global/Modals/MConfirmation";
import { getTrackingLink } from "../../../../../utils/shipping";
import DropdownButton from "../../../../../components/theme/buttons/DropdownButton";
import CalculateIcon from '@mui/icons-material/Calculate';
import { useCalculateShipmentCostsMutation } from "../../../../../newapi/financial/invoiceSlice";

const SpOrderDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpOrderDetails/SpOrderDetails"));
const SpReturnDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpReturnDetails/SpReturnDetails"));
const SpRelationDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpRelationDetails/SpRelationDetails"));
const SpShipperDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpShipperDetails/SpShipperDetails"));

const GridActions = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    return <></>;
}

const ShipmentsWithoutSendingCosts = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [data, setData] = useState([]);
    const [isExtended, setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();
    const [returnIsExtended, setReturnIsExtended] = useState(false);
    const [returnSpLoading, setReturnSpLoading] = useState();
    const [shipperIsExtended, setShipperIsExtended] = useState(false);
    const [shipperSpLoading, setShipperSpLoading] = useState();
    const [relationIsExtended, setRelationIsExtended] = useState(false);
    const [relationSpLoading, setRelationSpLoading] = useState();

    const gridOptions = {
        export:true,
        disableCustomActionsOnPhone: true,
        isSidepanel: true,
        filter: [
            SHIPMENTS_FILTER_KEYS.SHIPPER,
            SHIPMENTS_FILTER_KEYS.SHIPPER_PROFILE,
            SHIPMENTS_FILTER_KEYS.SHIPMENT_STATUS,
            SHIPMENTS_FILTER_KEYS.RELATION,
            SHIPMENTS_FILTER_KEYS.COUNTRY,
            SHIPMENTS_FILTER_KEYS.ORDERS_WITH_MULTIPLE,
        ],
    };
    
    const ref = useRef();
    const [config, setConfig] = useState({withoutCosts: true});

    const hasModifyPrivilege = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.INVOICE_MANAGE])
    );
        
    const [selectedItems, setSelectedItems] = useState([]);
    const onSelected = (selectedItems) => {
        setSelectedItems(selectedItems);
    }
        
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);
    const confirmModal = {
        open: confirmModalOpen,
        setOpen: setConfirmModalOpen,
    };

    const handleConfirmModalClose = () => {
        confirmModal.setOpen(false);
    };
    
    const [calculateModalOpen, setCalculateModalOpen] = useState(false);
    const calculateModal = {
        open: calculateModalOpen,
        setOpen: setCalculateModalOpen,
    };

    const handleCalculateModalClose = () => {
        calculateModal.setOpen(false);
    };

    const [loaderModalOpen, setLoaderModalOpen] = useState(false);
    const loaderModal = {
        open: loaderModalOpen,
        setOpen: setLoaderModalOpen,
    };

    const [bulkUpdateShipments, {isLoading: updateLoading}] = useBulkUpdateShipmentsMutation();
    const handleBulkUpdateShipments = async() => {
        try {
            if (updateLoading) return;

            loaderModal.setOpen(true);

            const response = await bulkUpdateShipments({shipmentIds:selectedItems, ignoreCosts: true}).unwrap();
            showToastMessageUpdateRequest(t, response);
        } catch (e) {
            showToastMessageRequestError(t('update_failed'), t, e);
        } finally {
            loaderModal.setOpen(false);
        }
    }

    const [calculateShipmentCosts, {isLoading: calculateLoading}] = useCalculateShipmentCostsMutation();
    const handleCalculateShipmentCosts = async() => {
        try {
            if (calculateLoading) return;

            loaderModal.setOpen(true);

            const response = await calculateShipmentCosts({shipmentIds:selectedItems}).unwrap();
            // Shipments of an order without calculated shipping costs are skipped by the backend
            if (response.skippedOrders?.length > 0) {
                showToastMessage("warning", t("shipment_costs_skipped_orders", { orders: response.skippedOrders.join(", ") }), 10000);
            } else {
                showToastMessageUpdateRequest(t, response);
            }
        } catch (e) {
            showToastMessageRequestError(t('update_failed'), t, e);
        } finally {
            loaderModal.setOpen(false);
        }
    }

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
        });

        return () => {
        }
    },[]);

    const [orderId, setOrderId] = useState();
    const orderIdRef = useRef(orderId);
    
    const getOrderDetails = (params) => {
        if (!params?.row?.order) return;
    
        const newOrderId = parseInt(params.row.order.id);
        // Only update state if the productId has actually changed
        if (orderIdRef.current !== newOrderId) {
            if(!spLoading) {
                setSpLoading(true);
            }
            setOrderId(newOrderId);
            orderIdRef.current = newOrderId; // Update the ref to the new value
        }
        setIsExtended(true);
    };

    const [returnId, setReturnId] = useState();
    const returnIdRef = useRef(orderId);
    
    const getReturnDetails = (params) => {
        if (!params?.row?.return) return;
    
        const newReturnId = parseInt(params.row.return.id);
        // Only update state if the productId has actually changed
        if (returnIdRef.current !== newReturnId) {
            if(!spLoading) {
                setReturnSpLoading(true);
            }
            setReturnId(newReturnId);
            returnIdRef.current = newReturnId; // Update the ref to the new value
        }
        setReturnIsExtended(true);
    };

    const [shipperId, setShipperId] = useState();
    const shipperIdRef = useRef(shipperId);
    
    const getShipperDetails = (params) => {
        if (!params?.row?.shipper) return;
    
        const newShipperId = parseInt(params.row.shipper.id);
        // Only update state if the productId has actually changed
        if (shipperIdRef.current !== newShipperId) {
            if(!shipperSpLoading) {
                setShipperSpLoading(true);
            }
            setShipperId(newShipperId);
            shipperIdRef.current = newShipperId; // Update the ref to the new value
        }
        setShipperIsExtended(true);
    };

    const [relationId, setRelationId] = useState();
    const relationIdRef = useRef(relationId);
    
    const getRelationDetails = (selectedRelation) => {
        if (!selectedRelation) return;
    
        const newRelationId = parseInt(selectedRelation);
        // Only update state if the productId has actually changed
        if (relationIdRef.current !== newRelationId) {
            if(!relationSpLoading) {
                setRelationSpLoading(true);
            }
            setRelationId(newRelationId);
            relationIdRef.current = newRelationId; // Update the ref to the new value
        }
        setRelationIsExtended(true);
    };

    const columns = [
        {
            field: "relation",
            headerName: t("relation"),
            flex:1,
            sortable: false,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                let relationName = "";
                if (params.row.order && !params.row.return) {
                    relationName = params.row.order.relation;
                } else if (params.row.return) {
                    relationName = params.row.return.relation;
                }

                const handleClick = (event) => {
                    let selectedRelation = "";
                    if (params.row.order && !params.row.return) {
                        selectedRelation = params.row.order.relationId;
                    } else if (params.row.return) {
                        selectedRelation = params.row.return.relationId;
                    }

                    event.stopPropagation(); // Prevent click from propagating to the row
                    getRelationDetails(selectedRelation);
                };

                return (
                    <Box sx={{height:1,display:"flex",flexDirection:"column",justifyContent:"center"}} onClick={handleClick}>
                        <Text bold clickable={true} variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{relationName}</Text>
                    </Box>
                );
            }
        },
        {field: "linkedTo", headerName: t("linked_to"),flex:1, sortable: false,
            renderCell: (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }

            const handleClick = (event) => {
                let type = "";
                if (params.row.order && !params.row.return) {
                    type = "order";
                } else if (params.row.return) {
                    type = "return";
                }

                event.stopPropagation(); // Prevent click from propagating to the row
                if (type === "order") {
                    getOrderDetails(params);
                } else if (type === "return") {
                    getReturnDetails(params);
                }
            };

            let description = "";
            if (params.row.order && !params.row.return) {
                description = `${t("order")} - ${params.row.order.barcode}`;
            } else if (params.row.return) {
                description = `${t("return")} - ${params.row.return.reference}`;
            }

            return (
                <Box sx={{height:1,display:"flex",flexDirection:"column",justifyContent:"center"}} onClick={handleClick}>
                    <Text bold clickable={true} variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{description}</Text>
                </Box>
            );
        }},
        {
            field: "trackingNumber",
            headerName: t("tracking_number"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                let trackingUrl = "";
                try {
                    trackingUrl = getTrackingLink(params.row);
                } catch (e) {
                    console.log(e);
                }

                if (!trackingUrl) {
                    return params.row.trackingNumber;
                }

                return (
                <Box sx={{height:1,display:"flex",flexDirection:"column",justifyContent:"center"}} onClick={() => {window.open(trackingUrl, "_blank")}}>
                    <Text bold clickable={true} variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{params.row.trackingNumber}</Text>
                </Box>)
            }
        },
        {
            field: "country",
            headerName: `${t("postal")} / ${t("country")}`,
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                
                return `${params.row.postal} / ${params.row.country?.toUpperCase()}`;
            }
        },
        {
            field: "shipper",
            headerName: t("shipper"),
            flex:2,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                const handleClick = (event) => {
                    event.stopPropagation(); // Prevent click from propagating to the row
                    getShipperDetails(params);
                };

                return (
                    <Box sx={{height:1,display:"flex",flexDirection:"column",justifyContent:"center"}} onClick={handleClick}>
                        <Text bold clickable={true} variant={theme.palette.mode === "dark" ? "blue" : "primary"}>
                            {`${params.row.shipper?.name} - ${params.row.shipperProfile?.name}`}
                        </Text>
                    </Box>
                );
            }
        },
        {
            field: "DaW",
            headerName: t("daw"),
            flex:3,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                const volume = params.row.shipperLength * params.row.shipperWidth * params.row.shipperHeight / 1000000;
                let dawString = `${t("warehouse")}: ${params.row.length} x ${params.row.width} x ${params.row.height} / ${volume}L / ${params.row.weight}g`;

                if (params.row.shipperLength > 0) {
                    const shipperVolume = params.row.shipperLength * params.row.shipperWidth * params.row.shipperHeight / 1000000;
                    dawString += ` - ${t("shipper")}: ${params.row.shipperLength} x ${params.row.shipperWidth} x ${params.row.shipperHeight} / ${shipperVolume}L / ${params.row.shipperWeight}g`
                } else if (params.row.shipperWeight > 0) {
                    dawString += ` - ${t("shipper")}: ${params.row.shipperWeight}g`
                }
                
                return dawString;
            }
        },
        {
            field: "shipmentStatus",
            headerName: t("shipment_status"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                if (!params.row.shipmentStatus) {
                    return "";
                }

                const stateData = getShipmentStatusLabeldata(params.row.shipmentStatus, theme);
                let labelcolor = stateData.labelcolor;
                let labeltext = stateData.labeltext;

                // If there are shipper events, wrap the label with SHQuickAction
                if (params.row.shipperEvents && params.row.shipperEvents.length > 0) {
                    return (
                        <SHQuickAction
                            maxWidth={700}
                            component={
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        pt: 2,
                                        px: 2,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            position: "relative",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 2,
                                        }}
                                    >
                                        <Text
                                            bold
                                            sx={{ width: "140px", flexShrink: 0 }}
                                        >
                                            {t("date")}
                                        </Text>
                                        <Text
                                            bold
                                            sx={{ width: "140px", flexShrink: 0 }}
                                        >
                                            {t("type")}
                                        </Text>
                                        <Text
                                            bold
                                            sx={{ minWidth: "350px", flexShrink: 0 }}
                                        >
                                            {t("status")}
                                        </Text>
                                    </Box>

                                    {params.row.shipperEvents.map((event, index) => (
                                        <Box
                                            key={index + "event"}
                                            sx={{
                                                position: "relative",
                                                minHeight: 40,
                                                py: 1,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 2,
                                            }}
                                        >
                                            <Text sx={{ width: "140px", flexShrink: 0 }}>
                                                {event.timeStamp ? new Date(event.timeStamp).toLocaleString(i18n.language) : "-"}
                                            </Text>
                                            <Text sx={{ width: "140px", flexShrink: 0 }}>
                                                {event.type}
                                            </Text>
                                            <Text sx={{ minWidth: "350px", flexShrink: 0 }}>
                                                {event.status}
                                            </Text>
                                        </Box>
                                    ))}
                                </Box>
                            }
                        >
                            {({anchorEl, onMouseEnter, onMouseLeave, onTouchStart}) => (
                                <Box
                                    aria-owns={anchorEl ? "simple-popover" : undefined}
                                    aria-haspopup="true"
                                    onMouseEnter={onMouseEnter}
                                    onMouseLeave={onMouseLeave}
                                    onTouchStart={onTouchStart}
                                    sx={{
                                        display: "inline-flex",
                                    }}
                                >
                                    <ShLabel size={32} palette="normal" variant={labelcolor}>
                                        {t(labeltext)}
                                    </ShLabel>
                                </Box>
                            )}
                        </SHQuickAction>
                    );
                }

                // No events, just show the label
                return (
                    <ShLabel size={32} palette="normal" variant={labelcolor}>
                      {t(labeltext)}
                    </ShLabel>
                );
              }
        },
        {
            field: "shipmentDate", 
            headerName: t("date_shipped"),
            flex:1,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                let date = params.row.shipmentDate && params.row.shipmentDate !== null ? new Date(params.row.shipmentDate) : undefined;
              
                return (
                    <Text>
                        {date ? date.toLocaleDateString(i18n.language) : "-"}
                    </Text>
                );
            }
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                // WarehouseInvoiceCard
                // return (
                //     // <WarehouseInvoiceCard
                //     //     onClick={() => getInvoice(params)}
                //     //     skeleton={params.row.skeleton}
                //     //     {...params.row}
                //     // />
                //     // <ShTextSkeleton/>
                // )
            }
        },
    ];

    return (
        <Box height={1} ref={ref} display={"flex"} flexDirection={"column"}>
            {/* <GridActions></GridActions> */}
            <ShDataGrid2 key={theme.palette.mode}
                content={useGetShipmentsQuery}
                config={config}
                gridActions={<GridActions></GridActions>} 
                title={t('all')}
                gridOptions={gridOptions} 
                sortModel={{field: columns[7].field,type:"DESC"}}
                columns={columns}
                rows={data}

                selectable={hasModifyPrivilege}
                setSelected={hasModifyPrivilege ? onSelected : undefined}
                selectedItems={hasModifyPrivilege ? selectedItems: undefined}

                selectedActions={
                    hasModifyPrivilege &&
                    <ShDataGridSelectedActions selectedItems={selectedItems}>
                        <DropdownButton onClick={() => calculateModal.setOpen(true)} icon={<CalculateIcon/>} text={t("recalculate_invoice_product")}/>
                        <DropdownButton onClick={() => confirmModal.setOpen(true)} icon={<DownloadOutlinedIcon/>} text={t("ignore_shipping_costs")}/>
                    </ShDataGridSelectedActions>
                }
                >
            </ShDataGrid2>

            <MConfirmation
                open={calculateModal.open}
                handleClose={handleCalculateModalClose}
                title={t("calculate_order_costs")}
                content={t("are_you_sure_you_want_to_calculate_the_costs")}
                confirm={() => handleCalculateShipmentCosts()}
            />

            <MConfirmation
                open={confirmModal.open}
                handleClose={handleConfirmModalClose}
                title={t("ignore_shipping_costs")}
                content={t("mc_ignore_shipping_costs_text")}
                confirm={() => handleBulkUpdateShipments()}
            />

            <MLoader
                open={loaderModal.open}
                message={t("calculating_order_costs")}
            />

            {spLoading && 
                <SpOrderDetails
                    orderId={orderId}
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    // data={pickingJobData}
                /> 
            }
            {returnSpLoading && 
                <SpReturnDetails
                    returnId={returnId}
                    isExtended={returnIsExtended}
                    setIsExtended={setReturnIsExtended}
                    // data={pickingJobData}
                /> 
            }

            {shipperSpLoading && 
                <SpShipperDetails
                    shipperId={shipperId}
                    isExtended={shipperIsExtended}
                    setIsExtended={setShipperIsExtended}
                /> 
            }
            {relationSpLoading && 
                <SpRelationDetails
                    relationId={relationId}
                    isExtended={relationIsExtended}
                    setIsExtended={setRelationIsExtended}
                /> 
            }
        </Box>
    );
}

export default ShipmentsWithoutSendingCosts;